export async function scrollToRouteHash(hash) {
  if (!hash) return

  await scrollToHashWhenReady(hash)
}

async function scrollToHashWhenReady(hash) {
  if (!hash) return

  let element = document.querySelector(hash)

  if (!element) {
    element = await waitStableLayout(hash)
  }

  if (!element) return

  await waitForImagesBeforeElement(element)

  element = await waitStableLayout(hash, {
    stableMs: 1000,
    maxMs: 5000,
    tolerance: 1,
  })

  if (!element) return

  element.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  })
}

function waitStableLayout(selector, options = {}) {
  const stableMs = options.stableMs || 400
  const maxMs = options.maxMs || 5000
  const tolerance = options.tolerance || 1

  return new Promise(resolve => {
    const startedAt = performance.now()
    let stableStartedAt = null
    let lastTop = null
    let lastHeight = null

    function check() {
      const element = document.querySelector(selector)

      if (!element) {
        if (performance.now() - startedAt < maxMs) {
          requestAnimationFrame(check)
          return
        }

        resolve(null)
        return
      }

      const currentTop = element.getBoundingClientRect().top + window.pageYOffset
      const currentHeight = document.documentElement.scrollHeight

      const isTopStable = lastTop !== null && Math.abs(currentTop - lastTop) <= tolerance
      const isHeightStable = lastHeight !== null && Math.abs(currentHeight - lastHeight) <= tolerance

      if (isTopStable && isHeightStable) {
        if (stableStartedAt === null) {
          stableStartedAt = performance.now()
        }
      } else {
        stableStartedAt = null
      }

      lastTop = currentTop
      lastHeight = currentHeight

      const isStableLongEnough = stableStartedAt !== null && performance.now() - stableStartedAt >= stableMs
      const isTimeout = performance.now() - startedAt >= maxMs

      if (isStableLongEnough || isTimeout) {
        resolve(element)
        return
      }

      requestAnimationFrame(check)
    }

    requestAnimationFrame(check)
  })
}

function waitForImagesBeforeElement(element) {
  if (!element) {
    return Promise.resolve()
  }

  const images = Array.from(document.images).filter(img => {
    const isBeforeTarget = img.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING

    return isBeforeTarget && !img.complete
  })

  if (!images.length) {
    return Promise.resolve()
  }

  return Promise.all(
    images.map(img => {
      return new Promise(resolve => {
        img.addEventListener('load', resolve, { once: true })
        img.addEventListener('error', resolve, { once: true })
      })
    })
  )
}



// WEBPACK FOOTER //
// ./src/modules/shared/utils/scroll.js